import {Controller} from "@hotwired/stimulus"

export default class LongPressController extends Controller {
    static values = {delay: Number}

    connect() {
        this.delay = this.hasDelayValue ? this.delayValue : 500
        this.tooltip = new bootstrap.Tooltip(this.element)
        this.pressTimer = null
        this.longPressActive = false
        this.preventClick = false

        // Event listeners
        this.element.addEventListener("mousedown", this.onMouseDown)
        this.element.addEventListener("mouseup", this.onMouseUp)
        this.element.addEventListener("mouseleave", this.onCancel)
        this.element.addEventListener("touchstart", this.onTouchStart, {passive: false})
        this.element.addEventListener("touchend", this.onTouchEnd)
        this.element.addEventListener("touchcancel", this.onCancel)
        this.element.addEventListener("click", this.onClick, true)
        this.element.addEventListener("contextmenu", this.onContextMenu)
    }

    disconnect() {
        this.tooltip.dispose()
        this.clearTimer()

        this.element.removeEventListener("mousedown", this.onMouseDown)
        this.element.removeEventListener("mouseup", this.onMouseUp)
        this.element.removeEventListener("mouseleave", this.onCancel)

        this.element.removeEventListener("touchstart", this.onTouchStart)
        this.element.removeEventListener("touchend", this.onTouchEnd)
        this.element.removeEventListener("touchcancel", this.onCancel)

        this.element.removeEventListener("click", this.onClick, true)
        this.element.removeEventListener("contextmenu", this.onContextMenu)
    }

    onMouseDown = () => this.startTimer()
    onMouseUp = (event) => this.finish(event)

    onTouchStart = (event) => {
        const isLink = event.target.closest('a')
        this.wasLinkTap = false

        event.preventDefault()
        if (isLink) {
            this.wasLinkTap = isLink
        }

        this.preventClick = false
        this.startTimer(() => {
            this.longPressActive = true
            this.tooltip.show()
            this.preventClick = true
        })
    }

    onTouchEnd = (event) => {
        this.finish(event)

        if (this.wasLinkTap && !this.longPressActive) {
            this.wasLinkTap.click()
        }
    }

    onClick = (event) => {
        if (this.preventClick) {
            event.preventDefault()
            event.stopImmediatePropagation()
            this.preventClick = false;
        } else {
            this.preventClick = true;
        }
    }

    onContextMenu = (event) => {
        if (this.longPressActive) {
            event.preventDefault()
        }
    }

    finish(event) {
        if (this.longPressActive) {
            this.tooltip.hide()
        }
        this.clearTimer()
    }

    onCancel = () => {
        this.tooltip.hide()
        this.clearTimer()
    }

    startTimer(callback) {
        this.clearTimer()
        this.longPressActive = false
        this.pressTimer = setTimeout(() => {
            this.longPressActive = true
            if (callback) callback()
        }, this.delay)
    }

    clearTimer() {
        if (this.pressTimer) {
            clearTimeout(this.pressTimer)
            this.pressTimer = null
        }
        this.longPressActive = false
    }
}
